import React from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

// Components
import Tippopover from "../UI/Tippopover";

const Radio = ({ label, name, id, options, error, tip }) => {
  const { register } = useFormContext();
  const { t } = useTranslation();

  return (
    <div className="mt-2 mb-4">
      <div className="d-flex justify-content-between form-label-container mb-2 form-label">
        <label className="">{label}</label>
        {tip && (
          <div className="tooltip-container">
            <button className="tooltip-button" type="button">
              <i className="bi bi-info-circle" />
            </button>
            <Tippopover tip={tip} />
          </div>
        )}
      </div>

      <div>
        {options.map((opt) => (
          <div className="form-check form-check-inline" key={opt.id}>
            <input
              className="form-check-input"
              type="radio"
              name={name}
              id={opt.id}
              value={opt.value}
              defaultChecked={opt.checked}
              {...register(id)}
            />
            <label className="form-check-label" htmlFor={opt.id}>
              {opt.label}
            </label>
          </div>
        ))}
      </div>
      {error && <div className="invalid-feedback">{t(error)}</div>}
    </div>
  );
};

export default Radio;
